import { render, staticRenderFns } from "./payin.vue?vue&type=template&id=16b21c14&scoped=true"
import script from "./payin.vue?vue&type=script&lang=js"
export * from "./payin.vue?vue&type=script&lang=js"
import style0 from "./payin.vue?vue&type=style&index=0&id=16b21c14&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b21c14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16b21c14')) {
      api.createRecord('16b21c14', component.options)
    } else {
      api.reload('16b21c14', component.options)
    }
    module.hot.accept("./payin.vue?vue&type=template&id=16b21c14&scoped=true", function () {
      api.rerender('16b21c14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/data-agent/payin.vue"
export default component.exports